// extracted by mini-css-extract-plugin
module.exports = {"popover-panel":"style_popover-panel__Cv2B8"};